import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appCssStyler]',
})
export class CssStylerDirective implements OnChanges, AfterViewInit {
  @Input('appCssStyler') cssStyle: string;
  @Input() wrapperClass: string;
  private _embeddedCssStyleRef: HTMLStyleElement;

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
  ) {}

  ngAfterViewInit() {
    this.renderer.addClass(this.elementRef.nativeElement, this.wrapperClass);
    this._injectCssStyle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.cssStyle && !changes.cssStyle.firstChange) ||
      (changes.wrapperClass && !changes.wrapperClass.firstChange)
    ) {
      this._updateEmbeddedCssStyle();
    }
  }

  private _injectCssStyle() {
    this._embeddedCssStyleRef = this.renderer.createElement('style');
    this.renderer.appendChild(
      this.elementRef.nativeElement,
      this._embeddedCssStyleRef,
    );
    this._updateEmbeddedCssStyle();
  }

  private _updateEmbeddedCssStyle() {
    const wrapperClass = this.wrapperClass ? '.' + this.wrapperClass : '';
    this.renderer.setProperty(
      this._embeddedCssStyleRef,
      'textContent',
      `${wrapperClass} { ${this.cssStyle ?? ''} }`,
    );
  }
}
